import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, InjectionToken, ModuleWithProviders, NgModule, Pipe, PipeTransform } from '@angular/core';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { SimpleNotificationsModule } from 'angular2-notifications';
import * as moment from 'moment';
import { OWL_DATE_TIME_LOCALE } from 'ng-pick-datetime';
import { MaterialModule } from 'src/app/material.module';
import { TimeAgoPipe as TimeAgoPipeOriginal } from 'time-ago-pipe';
import { V2NodeApiModule } from '../v2-node-api/v2-node-api.module';
import { AutocompleteChipsInputComponent } from './components/autocomplete-chips-input/autocomplete-chips-input.component';
import { ConfirmationDialogComponent } from './components/confirmation-dialog/confirmation-dialog.component';
import { DisplayFileIconComponent } from './components/display-file-icon/display-file-icon.component';
import { DocumentBreadcrumbComponent } from './components/document-breadcrumb/document-breadcrumb.component';
import { ExtractPdfButtonComponent } from './components/extract-pdf-button/extract-pdf-button.component';
import { FileExplorerComponent } from './components/file-explorer/file-explorer.component';
import { FormLoginComponent } from './components/form-login/form-login.component';
import { HelpComponent } from './components/help/help.component';
import { FileSizePipe } from './pipes/fileSize.pipe';
import { TeamPresentationComponent } from './components/team-presentation/team-presentation.component';
import { DialogSeeVersionsComponent } from '../+home/+my-libraries/+sites/document-library/shared/dialog-see-versions/dialog-see-versions.component';
import { SeeTrashcanComponent } from '../+home/+trashcan/see-trashcan/see-trashcan.component';
import { MatTreeModule } from '@angular/material/tree';
import { HighlightPipe } from '../+home/shared/pipe/highlight.pipe';

import { TranslationModule } from '../translation.module';
import { DisplaySearchResultsComponent } from '../+home/search/shared/components/display-search-results/display-search-results.component';
import { FiltersComponent } from '../+home/search/shared/components/filters/filters.component';
import { AtivityFilterComponent } from '../+home/+activities/ativity-filter/ativity-filter.component';
import { DropzoneDirective } from '../+home/+my-libraries/+sites/document-library/shared/directives/dropzone.directive';
import { DragDropSignatureDirective } from '../viewer/shared/directives/drag-drop-signature.directive';
import { DialogAddDocumentRequestComponent } from '../+home/+document-request/dialog-add-document-request/dialog-add-document-request.component';
import { PreviewComponent } from '../+home/+my-libraries/+sites/document-library/shared/preview/preview.component';
import { PdfViewerComponent, TxtViewerComponent, ViewerModule, MediaPlayerComponent, ImgViewerComponent } from '../viewer';
import { DisplayInfosDocumentComponent } from '../viewer/shared/components/display-infos-document/display-infos-document.component';
import { MenuFileOptionsComponent } from '../+home/+my-libraries/+sites/document-library/shared/menu-file-options/menu-file-options.component';
import { ToolbarComponent, ToolbarDividerComponent, ToolbarTitleComponent } from '../toolbar';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NotificationMenuComponent } from '../notifications/notification-menu/notification-menu.component';
import { NotificationComponent } from '../notifications/notification/notification.component';
import { NotificationIconComponent } from '../notifications/notification-icon/notification-icon.component';
import { NotificationBadgeComponent } from '../notifications/notification-badge/notification-badge.component';
import { AlertComponent } from '../notifications/domains/alert/alert.component';
import { MessageComponent } from '../notifications/domains/message/message.component';
import { NotificationsTabComponent } from '../notifications/notifications-tab/notifications-tab.component';
import { DocumentRequestNotificationsComponent } from '../notifications/domains/document-request/document-request.component';
import { ModalAskWorkflowComponent } from '../viewer/shared/modals/modal-ask-workflow/modal-ask-workflow.component';
import { DialogLoginComponent } from '../public/public-preview/shared/component/dialog-login/dialog-login.component';
import { PdfPasswordDialogComponent } from '../viewer/components/pdfViewer-password-dialog';
import { DisplayCountPipe } from '../+home/search/shared/filters/display-count.pipe';
import { CalculateTotalSearchPositionPipe } from '../viewer/shared/pipes/calculate-total-search-position.pipe';
import { ShakeDirective } from './directives/shake.directive';
import { FadeDirective } from './directives/fade.directive';
import { RingDirective } from './directives/ring.directive';
import { TextAppearDirective } from './directives/text-appear.directive';
import { SeeRequestsComponent } from '../+home/+document-request/see-requests/see-requests.component';
import { DocumentRequestModule } from '../+home/+document-request/document-request.module';
import { UploadDocumentsComponent } from '../+home/+document-request/upload-documents/upload-documents.component';
import { DialogEditRequestComponent } from '../+home/+document-request/dialog-edit-request/dialog-edit-request.component';
import { DocumentRequestComponent } from '../+home/+document-request/document-request.component';
import { RequestTemplateComponent } from '../+home/+document-request/request-template/request-template.component';
import { CreateRequestTemplateComponent } from '../+home/+document-request/create-request-template/create-request-template.component';
import { DisplayAccordionRequestsComponent } from '../+home/+document-request/display-accordion-requests/display-accordion-requests.component';
import { LastFileDatePipe } from '../+home/+document-request/see-requests/shared/components/pipes/last-file-date.pipe';
import { SeeAlertsComponent } from '../+home/+alerts/see-alerts/see-alerts.component';
import { WorkflowComponent } from '../notifications/domains/workflow/workflow.component';
import { GroupNames } from '../users/+users/see-users/shared/pipes/groupNames.pipe';
import { PermissionPipePipe } from './pipes/permission-pipe.pipe';
import { GroupNamesPipePipe } from './pipes/group-names-pipe.pipe';
import { WorkspaceRemoveComponent } from '../+home/+my-libraries/+workspaces/workspace-remove/workspace-remove.component';
import { GButtonComponent } from '../+home/shared/components/g-button/g-button.component';
import { GTextInputComponent } from '../+home/shared/components/g-text-input/g-text-input.component';
import { GMultipleSelectComponent } from '../+home/shared/components/g-multiple-select/g-multiple-select.component';
import { GAutocompleteComponent } from '../+home/shared/components/g-autocomplete/g-autocomplete.component';
import { AutocompleteChipsAsyncComponent } from './components/autocomplete-chips-async/autocomplete-chips-async.component';

import { AngularEditorModule } from '@kolkov/angular-editor';
import { HttpClientModule} from '@angular/common/http';
import { SellerAddConsultantComponent } from '../+home/+seller-consultants/seller-add-consultant/seller-add-consultant.component';





export const MOMENT_TOKEN = new InjectionToken('moment');

@Pipe({ name: 'timeAgo' })
export class TimeAgoPipe extends TimeAgoPipeOriginal implements PipeTransform {
}

const COMPONENTS = [
  AutocompleteChipsInputComponent,
  ConfirmationDialogComponent,
  DisplayFileIconComponent,
  DocumentBreadcrumbComponent,
  SeeTrashcanComponent,
  ExtractPdfButtonComponent,
  FileExplorerComponent,
  FileSizePipe,
  GroupNames,
  FormLoginComponent,
  TimeAgoPipe,
  HighlightPipe,
  DisplaySearchResultsComponent,
  FiltersComponent,
  AtivityFilterComponent,
  DropzoneDirective,
  DragDropSignatureDirective,
  DialogAddDocumentRequestComponent,
  TeamPresentationComponent,
  DialogSeeVersionsComponent,
  DropzoneDirective,
  PreviewComponent,
  PdfViewerComponent,
  ImgViewerComponent,
  TxtViewerComponent,
  DisplayInfosDocumentComponent,
  ToolbarComponent,
  ToolbarTitleComponent,
  ToolbarDividerComponent,
  MenuFileOptionsComponent,
  NotificationMenuComponent,
  NotificationComponent,
  NotificationIconComponent,
  NotificationBadgeComponent,
  AlertComponent,
  WorkflowComponent,
  MessageComponent,
  NotificationsTabComponent,
  HelpComponent,
  DocumentRequestNotificationsComponent,
  ModalAskWorkflowComponent,
  TxtViewerComponent,
  DialogLoginComponent,
  PdfPasswordDialogComponent,
  MediaPlayerComponent,
  ImgViewerComponent,
  MediaPlayerComponent,
  DisplayCountPipe,
  CalculateTotalSearchPositionPipe,
  ShakeDirective,
  FadeDirective,
  RingDirective,
  TextAppearDirective,
  SeeRequestsComponent,
  UploadDocumentsComponent,
  SeeRequestsComponent,
  DialogEditRequestComponent,
  DocumentRequestComponent,
  RequestTemplateComponent,
  CreateRequestTemplateComponent,
  DisplayAccordionRequestsComponent,
  LastFileDatePipe,
  SeeAlertsComponent,
  WorkspaceRemoveComponent,
  GButtonComponent,
  GTextInputComponent,
  GMultipleSelectComponent,
  GAutocompleteComponent,
  AutocompleteChipsAsyncComponent,
  SellerAddConsultantComponent
];

const MODULES = [
  CommonModule,
  FlexLayoutModule,
  FormsModule,
  ReactiveFormsModule,
  MaterialModule,
  NgxDatatableModule,
  RouterModule,
  SimpleNotificationsModule,
  MatTreeModule,
  TranslationModule,
  AngularEditorModule,
  HttpClientModule,
  NgbModule,

];


@NgModule({
  declarations: [...COMPONENTS, PermissionPipePipe, GroupNamesPipePipe],
  imports: [
    ...MODULES,
    V2NodeApiModule.forRoot(),
    SimpleNotificationsModule.forRoot(),

  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [
    ...MODULES,
    ...COMPONENTS,
    TeamPresentationComponent,
    SimpleNotificationsModule,
    GroupNamesPipePipe
  ],
  providers: [
    { provide: OWL_DATE_TIME_LOCALE, useValue: 'fr' },
    { provide: MOMENT_TOKEN, useValue: moment }
  ]
})
export class SharedModule {
  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
      providers: [{ provide: MOMENT_TOKEN, useValue: moment }]
    };
  }
}
